import { useState } from "react";
import { makeTransparent } from "shared/utils";
import { TierProps } from "../model/types";
import { TierCode, tierColors, tierImages } from "../model/tierAssets";
import { TierDetails } from "./TierDetails";
import { InfoIcon } from "shared/ui";
import styles from "./StatusTier.module.css";

export const StatusTier = ({ tier, number }: TierProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const code = tier.tier_code as TierCode;
  const color = tierColors[code];
  const imgSrc = tierImages[code];
  const amount = Math.trunc(Number(tier.min_deposit_usdt));
  const maxOpenOrders = Math.trunc(Number(tier.max_open_orders_usdt));

  return (
    <li className={styles.item}>
      <div
        className={styles.container}
        style={{
          boxShadow: `-0.9px -0.05px 0 0.2px ${color}`,
          backgroundColor: makeTransparent(color, 0.2, 80),
        }}
      >
        <div className={styles.tier}>
          <div className={styles.tierIcon}>
            <img
              className={styles.tierIconImg}
              src={imgSrc}
              alt={tier.display_name}
            />
          </div>
          <div className={styles.tierInfo}>
            <h3 className={styles.tierTitle}>{tier.display_name}</h3>
            <div
              className={styles.tierLabel}
              style={{
                color,
                backgroundColor: makeTransparent(color, 0.1),
              }}
            >{`Tier ${number}`}</div>
          </div>
        </div>
        <div className={styles.stats}>
          <div className={styles.stat}>
            <div className={styles.statLabel}>Min deposit</div>
            <div className={styles.statAmount}>
              <span>from</span>
              <span
                className={styles.amount}
              >{` $${amount.toLocaleString("en-US")}`}</span>
            </div>
          </div>
          <div className={styles.stat}>
            <div className={styles.statLabel}>Max open orders</div>
            <div className={styles.statAmount}>
              <span
                className={styles.amount}
              >{`$${maxOpenOrders.toLocaleString("en-US")}`}</span>
            </div>
          </div>
          <div
            className={styles.infoWrapper}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <button
              type="button"
              className={styles.infoBtn}
              aria-label="Show tier details"
            >
              <InfoIcon width={23} height={23} fill="#3a3d41" />
            </button>
            {isHovered && <TierDetails tier={tier} />}
          </div>
        </div>
      </div>
    </li>
  );
};
